export const responseCode = (params) => {
    return params?.responseCode;
}
export const responseMessage = (params) => {
    return params?.responseMessage;
}
export const responseResult = (params) => {
    return params?.responseResult;
}